module.exports = __webpack_public_path__ + "static/x86-oversea.8026aa34.png";